/* global modForm */
import {
	getHSGeoLookupDetails,
	getOwnHomeValue,
	mapServiceSpecificAttributes,
	trackFormSubmissionFlow
} from '../../helpers';

/**
 * Updating the formData object to match required format for new HS Forms Service API
 * @param {Object} formData - Object of form data
 * @returns {Object} Processed formData
 */
export function updateFormDataFormatForFormsService(formData = {}) {
	if (!formData && !Object.keys(formData).length) {
		trackFormSubmissionFlow({ noFormDataExitingUpdateFormDataFormatForFormsService: true });
		return;
	}

	trackFormSubmissionFlow({ inUpdateFormDataFormatForFormsService: true });

	const { addressSource, CCID, CLK, CROTag, EM, ExternalGlobalLeadID, FN, HeapEventID, HeapSessionID, HeapIdentity, HomePhoneConsentLanguage, HP, InternalSource, IsRealValidationEnabled, LN, Match, PartnerSourceID, PC, phoneActivityScore, PublisherSubID, QTR, quadlink, recaptchaCompleted, ReferredLead, S1, searchid, service, shClickKey, site, skipAddress, tagID, TestID, VariationName, TrustedFormToken } = formData;
	let { OwnHome } = formData;

	if (Object.keys(modForm.opts.serviceSpecificAttributes).length === 0) {
		mapServiceSpecificAttributes(service);
	} else {
		// Need to make sure OwnHome value is updated if OwnHome is on the last step of the form
		modForm.opts.serviceSpecificAttributes.OwnHome = getOwnHomeValue();
	}

	// OwnHome will be passed as a separate attribute (& not in the service specific)
	OwnHome = modForm.opts.serviceSpecificAttributes.OwnHome ? modForm.opts.serviceSpecificAttributes.OwnHome : OwnHome;
	delete modForm.opts.serviceSpecificAttributes.OwnHome;

	const additionalRootLevelAttributes = {
		...(TrustedFormToken && { 'trustedFormToken': TrustedFormToken }),
		...(PartnerSourceID && { 'partnerSourceID': PartnerSourceID }),
		...(PublisherSubID && { 'publisherSubID': PublisherSubID })
	};

	const consentCaptureData = {
		'consentMethod': 'Web',
		...(modForm.opts.consentRequestId && { 'requestId': modForm.opts.consentRequestId }),
		'vendors': modForm.opts.consentCaptureVendors,
		...(modForm.opts.consentCaptureLabels && { 'labels': modForm.opts.consentCaptureLabels })
	};

	const vendorMatchingSet = Match ? Match.split(',')?.map((vendor) => vendor?.trim()) : [];
	const isBrandedLead = vendorMatchingSet.length > 0;

	const matchingAttributes = {
		...(vendorMatchingSet && { matchVendors: vendorMatchingSet }),
		brandedLead: isBrandedLead
	};

	const serviceSpecificAttributes = {
		...modForm.opts.serviceSpecificAttributes
	};

	const configOverrideAttributes = {
		...(skipAddress === 'y' && { 'skipAddress': true }),
		...(IsRealValidationEnabled && { 'IsRealValidationEnabled': true })
	};

	const sureHitsAttributes = {
		...(searchid && { 'searchid': searchid }),
		...(shClickKey && { 'shclickkey': shClickKey })
	};

	const trackingAttributes = {
		...(CCID && { 'ccid': CCID }),
		...(CLK && { 'clk': CLK }),
		...(InternalSource && { 'internalSource': InternalSource }),
		...(QTR && { 'qtr': QTR }),
		...(quadlink && { 'quadLink': quadlink }),
		...(tagID && { 'quadTagId': tagID }),
		'site': site,
		'additionalAttributes': {
			...(HeapEventID && { 'HeapEventID': HeapEventID }),
			...(HeapSessionID && { 'HeapSessionID': HeapSessionID }),
			...(HeapIdentity && { 'HeapIdentity': HeapIdentity }),
			...(TestID && { 'TestID': TestID }),
			...(VariationName && { 'VariationName': VariationName }),
			...(CROTag && { 'CROTag': CROTag }),
			...(ExternalGlobalLeadID && { 'ExternalGlobalLeadID': ExternalGlobalLeadID }),
			...(ReferredLead && { 'ReferredLead': ReferredLead }),
			...(recaptchaCompleted && { 'recaptchaCompleted': recaptchaCompleted }),
			...(addressSource && { 'addressSource': addressSource }),
			...(phoneActivityScore && { 'phoneActivityScore': phoneActivityScore })
		}
	};

	let landingPageURL = window.location.href.split('#')[0];
	// This is a part of LP-3270, this will be removed once the analysis is done.
	const HSGeolookupData = JSON.stringify(window.currentLocationFromHSGeolookup || {});

	if (landingPageURL.includes('?')) {
		if (landingPageURL.charAt(landingPageURL.length - 1) !== '&') {
			landingPageURL += '&';
		}
		landingPageURL += 'HSGeolookupData=' + HSGeolookupData;
	} else {
		landingPageURL += '?HSGeolookupData=' + HSGeolookupData;
	}
	// LP-3270 -- end

	const HSGeoLookupDetails = JSON.stringify(getHSGeoLookupDetails());
	const querySymbol = landingPageURL.includes('?') ? '&' : '?';
	landingPageURL += `${querySymbol}HSGeoLookupDetails=${HSGeoLookupDetails}`;

	const formattedData = {
		'zip': PC,
		'service': service,
		'firstName': FN,
		'lastName': LN,
		'email': EM,
		'phone': HP,
		'address': S1,
		'ownHome': OwnHome,
		'homePhoneConsentLanguage': HomePhoneConsentLanguage,
		'landingPageURL': landingPageURL,
		...additionalRootLevelAttributes,
		'consentCaptureData': {
			...consentCaptureData
		},
		...(Object.keys(matchingAttributes).length ? { matchingAttributes } : {}),
		...(Object.keys(serviceSpecificAttributes).length ? { serviceSpecificAttributes } : {}),
		...(Object.keys(configOverrideAttributes).length ? { configOverrideAttributes } : {}),
		...(Object.keys(sureHitsAttributes).length ? { sureHitsAttributes } : {}),
		...(Object.keys(trackingAttributes).length ? { trackingAttributes } : {})
	};

	return formattedData;
}
